export default __webpack_public_path__ + "static/media/programme2.78c001e3.webp";